export async function backlogGetBacklogFulfillmentUseCase(date, backlogRepository) {

    const result = await backlogRepository.backlog_fulfillment(date);

    const entity = new backlogRepository.model_fulfillment(result.data.success.arguments)

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("Backlog fulfillment response invalido");
    }

    return entity;
}